var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHousingArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041C\\u0430\\u0441\\u0438\\u0432\\u0438",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.601,
    height: 15.601,
    viewBox: "0 0 15.601 15.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1691",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1691",
    d: "M376,451h.914v1.859H376Z",
    transform: "translate(-364.543 -437.258)",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1692",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1692",
    d: "M271,1.828V15.6h2.285V12.828h2.742V15.6h2.316V1.828L274.656,0Zm5.028,1.859h.914V4.6h-.914Zm0,1.828h.914v.914h-.914Zm0,1.828h.914v.914h-.914Zm0,1.828h.914v.914h-.914Zm0,1.828h.914v.914h-.914Zm-2.742.914h-.914V11h.914Zm0-1.828h-.914V9.172h.914Zm0-1.828h-.914V7.343h.914Zm0-1.828h-.914V5.515h.914Zm0-1.828h-.914V3.687h.914Zm1.828,7.313H274.2V11h.914Zm0-1.828H274.2V9.172h.914Zm0-1.828H274.2V7.343h.914Zm0-1.828H274.2V5.515h.914Zm0-1.828H274.2V3.687h.914Z",
    transform: "translate(-262.742)",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1693",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1693",
    d: "M106,451h.914v1.859H106Z",
    transform: "translate(-102.77 -437.258)",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1694",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1694",
    d: "M2.316,188.313H5.058v2.773H7.343v-8.258L3.687,181,0,182.828v8.258H2.316Zm2.742-3.656h.914v.914H5.058Zm0,1.828h.914v.914H5.058ZM3.23,184.656h.914v.914H3.23Zm0,1.828h.914v.914H3.23ZM1.4,184.656h.914v.914H1.4Zm0,1.828h.914v.914H1.4Z",
    transform: "translate(0 -175.485)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingArea);
export default __webpack_public_path__ + "static/media/HousingArea.16288ad60d6483452b11a94b6694ba40.svg";
export { ForwardRef as ReactComponent };